import { GroupInput } from '@/components/v2/group-input'
import { Input } from '@material-tailwind/react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

export const MainUserForm = () => {
  const { t } = useTranslation()

  const { values, handleChange } = useFormikContext()

  return (
    <GroupInput
      title={t('company.sections.mainUser')}
      description='Rellena la información del usuario principal que hará ingreso a la plataforma.'
      className='py-8'
    >

      <div className='grid grid-cols-2 gap-4'>
        <Input
          required
          name="user_attributes.first_name"
          label={t('common.firstName')}
          value={values.user_attributes.first_name}
          onChange={handleChange}
        />

        <Input
          required
          name="user_attributes.last_name"
          label={t('common.lastName')}
          value={values.user_attributes.last_name}
          onChange={handleChange}
        />

        <Input
          required
          name="user_attributes.email"
          label={t('email.one')}
          value={values.user_attributes.email}
          onChange={handleChange}
        />
      </div>
    </GroupInput>
  )
}
